export const locale = {
  most_recent_entry: 'Most Recent Entry',
  wellness_card_aria: '{{title}} - Most Recent Entry: {{entry}}',
};
